/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Contractprice1Inputs */

const en__field_contractprice1 = /** @type {(inputs: _Field_Contractprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary`)
};

const de__field_contractprice1 = /** @type {(inputs: _Field_Contractprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergütung`)
};

/**
* | output |
* | --- |
* | "Salary" |
*
* @param {_Field_Contractprice1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_contractprice1 = /** @type {((inputs?: _Field_Contractprice1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Contractprice1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_contractprice1(inputs)
	return de__field_contractprice1(inputs)
});
export { _field_contractprice1 as "_field_contractPrice" }